import React, { useEffect, useContext, useState, useRef } from "react";
import { SimpleTooltip } from "simple-ui-components";

import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import {
  BodyWrapperStyled,
  BoxStyled,
  CardHeader,
  CardBody,
  CardStyled,
  OuterWrapper,
  EmptyList,
} from "../../theme";
import { get, del } from "../../server-requests/serverRequests";
import { AuthContext } from "../authContextProvider";
import { LoadingList } from "../shared/loading";
import { ClientsDetail } from "./clientsDetail";
import { AddEditClient } from "./addEditClient";
import DeletePopup from "../shared/deletePopup";
import { Layout, useWindowSize } from "../layout/otherPage";
import { getTranslation, LanguageContext } from "../languageProvider";
import { Log, ReplaceWord } from "../shared/utility";

export const Clients = () => {
  const addEditClientRef = useRef();
  const deleteClientRef = useRef();

  const { Tooltip } = SimpleTooltip;

  const { wrapperHeight, boxHeight } = useWindowSize();

  const { snackbarHandler } = useContext(AuthContext);
  const { lang } = useContext(LanguageContext);

  const [reloadClients, setReloadClients] = useState(true);
  const [loadingClient, setLoadingClient] = useState(true);
  const [clientList, setClientList] = useState([]);

  // get clients list
  useEffect(() => {
    let isMounted = true;
    if (reloadClients) {
      get("clients/list")
        .then((client) => {
          if (isMounted) {
            setClientList(client);
            setReloadClients(false);
            setLoadingClient(false);
          }
        })
        .catch((status) => {
          setLoadingClient(false);
          setReloadClients(false);
          snackbarHandler(getTranslation(`error${status}`));
          Log("Error: get clients/list" + status);
        });
    }
    return () => (isMounted = false);
  }, [reloadClients, snackbarHandler]);

  // Clients
  const clientAddClickHandler = () =>
    addEditClientRef.current.AddEditClientHandler("add");

  const clientEditClickHandler = (client) =>
    addEditClientRef.current.AddEditClientHandler("edit", client);

  const updateClientSuccessHandler = () => setReloadClients(true);

  const clientDeleteClickHandler = (id) =>
    deleteClientRef.current.Delete(
      id,
      `${getTranslation("0032")} ${
        getTranslation("0072") && getTranslation("0072").toLowerCase()
      }`,
      getTranslation("0120") &&
        ReplaceWord(
          getTranslation("0120"),
          "**NAME**",
          getTranslation("0072").toLowerCase()
        )
    );

  const deleteClientHandler = (id) => {
    del("clients", {
      id,
    })
      .then(() => {
        snackbarHandler(
          getTranslation("0121") &&
            ReplaceWord(
              getTranslation("0121"),
              "**NAME**",
              getTranslation("0072")
            ),
          "success"
        );
        setReloadClients(true);
      })
      .catch((status) => {
        snackbarHandler(getTranslation(`error${status}`));
        Log("Error: delete clients" + status);
      });
  };

  return (
    <Layout lang={lang}>
      <OuterWrapper height={wrapperHeight}>
        <BodyWrapperStyled fullHeight>
          <BoxStyled noMargin>
            <CardStyled>
              <CardHeader>
                <PeopleOutlineIcon className="mainIcon" />
                <div className="detail" data-translate="0072">
                  {getTranslation("0072")}s
                  <span data-translate="0072,0078">
                    {getTranslation("0078") &&
                      ReplaceWord(
                        getTranslation("0078"),
                        "**NUMBER**",
                        clientList.length,
                        "**LISTNAME**",
                        getTranslation("0072").toLowerCase() + "s"
                      )}
                  </span>
                </div>
                <Tooltip
                  text={`${getTranslation("0087")} ${
                    getTranslation("0072") &&
                    getTranslation("0072").toLowerCase()
                  }`}
                  placement="left"
                >
                  <AddOutlinedIcon onClick={clientAddClickHandler} />
                </Tooltip>
              </CardHeader>
              <CardBody height={boxHeight}>
                {loadingClient && <LoadingList count={2} />}
                {!loadingClient && clientList.length === 0 && (
                  <EmptyList data-translate="0072,0123">
                    {getTranslation("0123") &&
                      ReplaceWord(
                        getTranslation("0123"),
                        "**NAME**",
                        getTranslation("0072").toLowerCase()
                      )}
                  </EmptyList>
                )}
                {!loadingClient &&
                  clientList.length > 0 &&
                  clientList.map((client, index) => (
                    <ClientsDetail
                      key={index}
                      client={client}
                      Edit={clientEditClickHandler}
                      Delete={clientDeleteClickHandler}
                    />
                  ))}
              </CardBody>
            </CardStyled>
          </BoxStyled>
        </BodyWrapperStyled>
        <AddEditClient
          ref={addEditClientRef}
          UpdateSuccess={updateClientSuccessHandler}
        />
        <DeletePopup
          ref={deleteClientRef}
          DeleteSuccess={deleteClientHandler}
        />
      </OuterWrapper>
    </Layout>
  );
};
